import { Box, Label } from "theme-ui";

import * as styles from "./ToggleText.styles";

// Based on: https://codesandbox.io/s/w7rwn53eo?file=/index.js
export default function ToggleText({
  name,
  value,
  options = [],
  onChange,
  isRound = false,
  size = "medium", // medium / large
}) {
  const optionsCount = options.length;
  const selectedIndex = options.findIndex((option) => option.value === value);

  const uniqueName = [
    name || "toggleText",
    Math.floor(Math.random() * 999999),
  ].join("-");

  return (
    <Box>
      <Box sx={styles.toggleText({ isRound })}>
        <Box sx={styles.container({ size })}>
          {options.map((option) => (
            <Label key={option.value}>
              <input
                type="radio"
                name={uniqueName}
                value={option.value}
                checked={value === option.value}
                onChange={() => onChange(option.value)}
              />
              <div>{option.label}</div>
            </Label>
          ))}

          <Box
            sx={styles.selection({ optionsCount, isRound })}
            style={{
              left: `calc(${(selectedIndex / optionsCount) * 100}%)`,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
